var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { QuerySelectorAllIncludingShadowDom } from "./ui/custom-elements.js";
const supportedLanguages = ["en"];
const primaryLanguage = "en";
const preferredLanguages = navigator.languages.map(lang => lang.substring(0, 2));
const autoSelectedLanguage = (() => {
    for (const preferred of preferredLanguages) {
        for (const supported of supportedLanguages) {
            if (preferred === supported) {
                return preferred;
            }
        }
    }
    return primaryLanguage;
})();
export const localizationAttribute = "data-locale-key";
const localeBasePath = "./assets/locale";
const localizedStrings = new Map();
let primaryLanguageStrings = new Map();
let currentLanguageStrings = new Map();
export let selectedLanguage = autoSelectedLanguage;
function UpdateElementLocalizedText(elem, knownLocaleKey) {
    let localeKey = knownLocaleKey !== null && knownLocaleKey !== void 0 ? knownLocaleKey : elem.getAttribute(localizationAttribute);
    if (localeKey !== null) {
        let textSetter = null;
        const colonIndex = localeKey.indexOf(":");
        if (colonIndex !== -1) {
            const target = localeKey.substring(0, colonIndex);
            localeKey = localeKey.substring(colonIndex + 1);
            switch (target) {
                case "placeholder":
                    if (elem instanceof HTMLInputElement || elem instanceof HTMLTextAreaElement) {
                        textSetter = text => (elem.placeholder = text);
                    }
                    break;
                default:
                    break;
            }
        }
        const localizedText = GetLocalizedString(localeKey);
        if (textSetter === null) {
            elem.textContent = localizedText;
        }
        else {
            textSetter(localizedText);
        }
    }
    else {
        elem.textContent = "[Not localized]";
    }
}
let firstLanguageSet = false;
export function SetLanguage(lang_1) {
    return __awaiter(this, arguments, void 0, function* (lang, force = false) {
        if (lang === selectedLanguage && firstLanguageSet && !force) {
            return;
        }
        firstLanguageSet = true;
        selectedLanguage = lang;
        currentLanguageStrings = yield LoadLanguageStrings(lang);
        if (selectedLanguage !== lang) {
            // Language was switched while loading
            return;
        }
        for (const elem of QuerySelectorAllIncludingShadowDom(`*[${localizationAttribute}]`)) {
            UpdateElementLocalizedText(elem);
        }
    });
}
export function GetLocalizedString(localeKey) {
    var _a, _b;
    return (_b = (_a = currentLanguageStrings.get(localeKey)) !== null && _a !== void 0 ? _a : primaryLanguageStrings.get(localeKey)) !== null && _b !== void 0 ? _b : localeKey;
}
export function LocalizeElement(elem, localeKey) {
    if (localeKey.startsWith("#")) {
        // Force raw text
        elem.textContent = localeKey.substring(1);
    }
    else {
        elem.setAttribute(localizationAttribute, localeKey);
        UpdateElementLocalizedText(elem, localeKey);
    }
}
function LoadLanguageStrings(lang) {
    return __awaiter(this, void 0, void 0, function* () {
        if (localizedStrings.has(lang)) {
            return localizedStrings.get(lang);
        }
        const strings = new Map();
        localizedStrings.set(lang, strings);
        try {
            const url = `${localeBasePath}/${lang}.json`;
            const req = yield fetch(url);
            const json = yield req.json();
            function IsObject(obj) {
                return typeof obj === "object" && !Array.isArray(obj);
            }
            function Visit(node, path) {
                for (const key in node) {
                    const value = node[key];
                    const currentPath = path === null ? key : path + "/" + key;
                    if (IsObject(value)) {
                        Visit(value, currentPath);
                    }
                    else if (typeof value === "string") {
                        strings.set(currentPath, value);
                    }
                }
            }
            Visit(json, null);
            if (lang === primaryLanguage) {
                primaryLanguageStrings = strings;
            }
        }
        catch (ex) {
            console.error("Unable to load localization data", ex);
        }
        return strings;
    });
}
Promise.all([
    LoadLanguageStrings(primaryLanguage), // Always load primary language
    LoadLanguageStrings(selectedLanguage),
]);
// TODO: Remove this later, only for debugging
window.SetLanguage = SetLanguage;
//# sourceMappingURL=localization.js.map